import ForeignHealthConfigurationTags from '@/modules/foreign-health/common/models/APP/ForeignHealthConfigurationTags'
import Configurations from '@/modules/common/common/models/APP/Configuration'
import schema from '@/modules/foreign-health/common/schemas/APP/ForeignHealthConfigurationsSchema'
import { validate } from '@/utils/schemaValidatorUtils'
import type { OptionsValuesInterface } from '@/modules/core/models/types'
import InsuranceType from '@/modules/common/common/models/DXP/InsuranceType'
import { ForeignHealthMinMaxAges } from './ForeignHealthMinMaxAges'
import { BillingCycles } from '@/modules/common/rater/models/DXP/BillingCycles'
import { ForeignHealthEndDateStudent } from './ForeignHealthEndDateStudent'

export default class ForeignHealthConfigurations extends Configurations<ForeignHealthMinMaxAges> {
  tags!: ForeignHealthConfigurationTags
  insuranceTypes: Record<string, InsuranceType>
  paymentTypes: Record<string, InsuranceType>
  minMonthEndDate: number
  maxMonthEndDate: number
  billingCyclesStudent?: BillingCycles
  billingCyclesResident?: BillingCycles
  hiringEndDateStudent?: ForeignHealthEndDateStudent
  startDateHeaderHint?: string

  constructor(data: any = {}) {
    if (data && Object.keys(data).length > 0) {
      validate(schema, data)
    }

    super(data)

    this.insuranceTypes = {}
    if (data?.insuranceTypes && Object.keys(data.insuranceTypes).length > 0) {
      Object.keys(data.insuranceTypes).forEach((k) => {
        this.insuranceTypes[k] = new InsuranceType(data.insuranceTypes[k])
      })
    }

    this.paymentTypes = {}
    if (data?.paymentTypes && Object.keys(data.paymentTypes).length > 0) {
      Object.keys(data.paymentTypes).forEach((k) => {
        this.paymentTypes[k] = new InsuranceType(data.paymentTypes[k])
      })
    }

    if (data?.tags) {
      this.tags = new ForeignHealthConfigurationTags(data.tags)
    }

    this.minMonthEndDate = Number(data.minMonthEndDate)
    this.maxMonthEndDate = Number(data.maxMonthEndDate)

    if (data.hiringMaxAges) {
      this.hiringMaxAges = new ForeignHealthMinMaxAges(data.hiringMaxAges)
    }
    if (data?.billingCyclesStudent) {
      this.billingCyclesStudent = new BillingCycles(data?.billingCyclesStudent)
    }
    if (data?.billingCyclesResident) {
      this.billingCyclesResident = new BillingCycles(data?.billingCyclesResident)
    }
    if (data?.hiringEndDateStudent) {
      this.hiringEndDateStudent = new ForeignHealthEndDateStudent(data?.hiringEndDateStudent)
    }
    this.startDateHeaderHint =
      'Podrás contratar un seguro con efecto retroactivo de una semana y hasta 5 meses después de la fecha actual. La duración del seguro es de 365 días. Si la duración de tu estancia es más de un año, podrás contratar de nuevo tu póliza tras este tiempo.'
  }

  get insuranceTypesOptions(): OptionsValuesInterface[] {
    return this.parseToOptions(this.insuranceTypes)
  }

  get defaultInsuranceType(): string | null {
    return this.getDefaultValue(this.insuranceTypes)
  }

  get paymentTypesOptions(): OptionsValuesInterface[] {
    return this.parseToOptions(this.paymentTypes)
  }

  get defaultPaymentType(): string | null {
    return this.getDefaultValue(this.paymentTypes)
  }
}
